
export const enProfile = {
  profile: {
    title: "Profile",
    myAccountProfile: "My Account Profile",
    myProfile: "My Profile",
    participantProfile: "Participant Profile",
    subtitles: {
      yourProfileInEvent: "Your profile in: {{eventName}}",
      profileInEvent: "Profile in: {{eventName}}",
      manageAccount: "Manage your account information and payment details"
    },
    notFound: "Profile not found",
    backToEvent: "Back to Event",
    backToHome: "Back to Home",
    authRequired: "Please sign in to view your profile.",
    notifications: {
      ownerPrivileges: {
        title: "Owner Privileges",
        message: "As the event owner, you can edit this participant's profile information."
      },
      limitedAccess: {
        title: "Limited Access",
        message: "You can view this event owner's profile but cannot edit their information."
      }
    },
    components: {
      profileInfoNotice: {
        title: "Profile Information",
        description1: "Your profile information is used to identify you in shared events and to process payments.",
        description2: "Bank information is securely stored and only used for payment calculations and settlement."
      },
      profileHeader: {
        roles: {
          eventOwner: "Event Owner",
          guestUser: "Guest User",
          participant: "Participant"
        },
        descriptions: {
          guestParticipant: "Guest participant in this event",
          eventOwnerAdmin: "Event owner and administrator"
        }
      },
      profileDetailsGrid: {
        displayName: "Display Name",
        ownerEdit: "(Owner Edit)",
        profileInformation: "Profile Information",
        emailAddress: "Email Address",
        memberSince: "Member Since",
        created: "Created",
        lastAccess: "Last Access",
        userId: "User ID",
        enterDisplayName: "Enter display name",
        saveChanges: "Save Changes",
        saving: "Saving...",
        cancel: "Cancel",
        edit: "Edit",
        scope: {
          legend: "Where should this name apply?",
          event: {
            label: "This event only",
            description: "Everyone sees the new name in this bill. Your other events and your account name stay as they are."
          },
          account: {
            label: "Everywhere (account name)",
            description: "Changes your account name and updates every event that still uses your old one. Events where you picked a different name keep it."
          },
          reset: {
            label: "Back to my account name",
            description: "Use \"{{name}}\" in this event again."
          }
        }
      },
      bankInfoSection: {
        title: "Bank Information",
        ownerEdit: "(Owner Edit)",
        bankName: "Bank Name",
        accountHolder: "Account Holder",
        accountNumber: "Account Number",
        noBankInfo: "No bank information available",
        editBankInfo: "Edit Bank Info",
        addBankInfo: "Add Bank Info"
      },
      preferencesSection: {
        title: "Settings",
        subtitle: "Saved to your account, so they follow you to every device and event.",
        splitFirst: {
          label: "Pick who shares first",
          description: "Put \"Split Between\" at the top of the Add Expense form, before the amount and description."
        },
        saveFailed: "Could not save the setting. Please try again."
      },
      bankInfoForm: {
        title: "Bank Information",
        editTitle: "Edit Bank Information",
        addTitle: "Add Bank Information",
        fields: {
          accountNumber: {
            label: "Account Number",
            labelRequired: "Account Number *",
            placeholder: "Enter account number"
          },
          bankName: {
            label: "Bank Name",
            labelRequired: "Bank Name *",
            placeholder: "Select your bank"
          },
          accountHolder: {
            label: "Account Holder",
            labelRequired: "Account Holder *",
            placeholder: "Enter account holder name"
          }
        },
        buttons: {
          save: "Save",
          saving: "Saving...",
          cancel: "Cancel",
          edit: "Edit"
        },
        errors: {
          fillAllFields: "Please fill in all required fields",
          pickBankFromList: "Please pick your bank from the list so the transfer QR code works",
          saveFailed: "Failed to save bank information"
        }
      },
      bankSelect: {
        title: "Select Bank",
        placeholder: "Select your bank",
        searchPlaceholder: "Search bank name or code...",
        noResults: "No bank matches \"{{query}}\"",
        count: "Showing {{shown}} of {{total}} banks",
        close: "Close",
        unknownBank: "Not in the VietQR list — pick again"
      }
    }
  }
};

export const viProfile = {
  profile: {
    title: "Hồ Sơ",
    myAccountProfile: "Hồ Sơ Tài Khoản",
    myProfile: "Hồ Sơ Của Tôi",
    participantProfile: "Hồ Sơ Người Tham Gia",
    subtitles: {
      yourProfileInEvent: "Hồ sơ của bạn trong: {{eventName}}",
      profileInEvent: "Hồ sơ trong: {{eventName}}",
      manageAccount: "Quản lý thông tin tài khoản và chi tiết thanh toán"
    },
    notFound: "Không tìm thấy hồ sơ",
    backToEvent: "Quay Lại Sự Kiện",
    backToHome: "Quay Lại Trang Chủ",
    authRequired: "Vui lòng đăng nhập để xem hồ sơ của bạn.",
    notifications: {
      ownerPrivileges: {
        title: "Quyền Chủ Sở Hữu",
        message: "Là chủ sự kiện, bạn có thể chỉnh sửa thông tin hồ sơ của người tham gia này."
      },
      limitedAccess: {
        title: "Quyền Truy Cập Hạn Chế",
        message: "Bạn có thể xem hồ sơ của chủ sự kiện này nhưng không thể chỉnh sửa thông tin của họ."
      }
    },
    components: {
      profileInfoNotice: {
        title: "Thông Tin Hồ Sơ",
        description1: "Thông tin hồ sơ của bạn được sử dụng để nhận dạng bạn trong các sự kiện chia sẻ và xử lý thanh toán.",
        description2: "Thông tin ngân hàng được lưu trữ an toàn và chỉ được sử dụng cho tính toán thanh toán và quyết toán."
      },
      profileHeader: {
        roles: {
          eventOwner: "Chủ Sự Kiện",
          guestUser: "Người Dùng Khách",
          participant: "Người Tham Gia"
        },
        descriptions: {
          guestParticipant: "Khách tham gia sự kiện này",
          eventOwnerAdmin: "Chủ sự kiện và quản trị viên"
        }
      },
      profileDetailsGrid: {
        displayName: "Tên Hiển Thị",
        ownerEdit: "(Chỉnh Sửa Bởi Chủ)",
        profileInformation: "Thông Tin Hồ Sơ",
        emailAddress: "Địa Chỉ Email",
        memberSince: "Thành Viên Từ",
        created: "Đã Tạo",
        lastAccess: "Truy Cập Cuối",
        userId: "ID Người Dùng",
        enterDisplayName: "Nhập tên hiển thị",
        saveChanges: "Lưu Thay Đổi",
        saving: "Đang lưu...",
        cancel: "Hủy",
        edit: "Chỉnh Sửa",
        scope: {
          legend: "Áp dụng tên này ở đâu?",
          event: {
            label: "Chỉ sự kiện này",
            description: "Mọi người thấy tên mới trong bill này. Các sự kiện khác và tên tài khoản của bạn giữ nguyên."
          },
          account: {
            label: "Đổi vĩnh viễn (tên tài khoản)",
            description: "Đổi tên tài khoản và cập nhật mọi sự kiện đang dùng tên cũ. Sự kiện nào bạn đã đặt tên riêng thì vẫn giữ tên đó."
          },
          reset: {
            label: "Về lại tên tài khoản",
            description: "Dùng lại tên \"{{name}}\" trong sự kiện này."
          }
        }
      },
      bankInfoSection: {
        title: "Thông Tin Ngân Hàng",
        ownerEdit: "(Chỉnh Sửa Bởi Chủ)",
        bankName: "Tên Ngân Hàng",
        accountHolder: "Chủ Tài Khoản",
        accountNumber: "Số Tài Khoản",
        noBankInfo: "Không có thông tin ngân hàng",
        editBankInfo: "Chỉnh Sửa Thông Tin Ngân Hàng",
        addBankInfo: "Thêm Thông Tin Ngân Hàng"
      },
      preferencesSection: {
        title: "Cài Đặt",
        subtitle: "Lưu theo tài khoản, áp dụng trên mọi thiết bị và mọi sự kiện.",
        splitFirst: {
          label: "Chọn người chia trước",
          description: "Đưa phần \"Chia Cho\" lên đầu form Thêm Chi Phí, trước số tiền và mô tả."
        },
        saveFailed: "Chưa lưu được cài đặt, bạn thử lại nhé."
      },
      bankInfoForm: {
        title: "Thông Tin Ngân Hàng",
        editTitle: "Chỉnh Sửa Thông Tin Ngân Hàng",
        addTitle: "Thêm Thông Tin Ngân Hàng",
        fields: {
          accountNumber: {
            label: "Số Tài Khoản",
            labelRequired: "Số Tài Khoản *",
            placeholder: "Nhập số tài khoản"
          },
          bankName: {
            label: "Tên Ngân Hàng",
            labelRequired: "Tên Ngân Hàng *",
            placeholder: "Chọn ngân hàng"
          },
          accountHolder: {
            label: "Chủ Tài Khoản",
            labelRequired: "Chủ Tài Khoản *",
            placeholder: "Nhập tên chủ tài khoản"
          }
        },
        buttons: {
          save: "Lưu",
          saving: "Đang lưu...",
          cancel: "Hủy",
          edit: "Chỉnh sửa"
        },
        errors: {
          fillAllFields: "Vui lòng điền tất cả các trường bắt buộc",
          pickBankFromList: "Vui lòng chọn ngân hàng trong danh sách để mã QR chuyển khoản hoạt động",
          saveFailed: "Không thể lưu thông tin ngân hàng"
        }
      },
      bankSelect: {
        title: "Chọn Ngân Hàng",
        placeholder: "Chọn ngân hàng",
        searchPlaceholder: "Tìm tên hoặc mã ngân hàng...",
        noResults: "Không tìm thấy ngân hàng nào khớp \"{{query}}\"",
        count: "Hiển thị {{shown}}/{{total}} ngân hàng",
        close: "Đóng",
        unknownBank: "Không có trong danh sách VietQR — hãy chọn lại"
      }
    }
  }
};